import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const CollapseContainer: React.FC<Props> = ({ children }) => {
    const theme = useTheme();

    const style = css`
        width: 100%;
        margin-bottom: 290px;

        ${theme.breakpoints.only("lg")} {
            margin-bottom: 250px;
        }

        ${theme.breakpoints.only("md")} {
            margin-bottom: 217px;
        }

        ${theme.breakpoints.down("sm")} {
            margin-bottom: 112px;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default CollapseContainer;